"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M5 5.5A1.5 1.5 0 0 1 6.5 4h11A1.5 1.5 0 0 1 19 5.5v11a1.5 1.5 0 0 1-1.5 1.5h-3.25v1.5a.75.75 0 0 1-1.166.624L12 19.401l-1.084.723A.75.75 0 0 1 9.75 19.5V18H6.5A1.5 1.5 0 0 1 5 16.5zm8.5 10.099A2.999 2.999 0 0 0 12 10a3 3 0 0 0-1.5 5.599v.008c.442.254.954.4 1.5.4s1.059-.146 1.5-.4zm-3 1.118V19.5l1.5-1 1.5 1v-2.783a4 4 0 0 1-1.5.29 4 4 0 0 1-1.5-.29M9 7.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5"
  })]
}), 'CertificateFilled');
